import React, { useLayoutEffect, useRef, useEffect, useState } from "react"
import { useStaticQuery, graphql } from "gatsby"
import Layout from "../components/layout"
import TransitionLink from 'gatsby-plugin-transition-link'
import VisibilitySensor from 'react-visibility-sensor'
import { Link } from "gatsby"
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger"
import { StaticImage } from "gatsby-plugin-image"
import Footer from "../components/footer"
import chevronDown from "../images/angle-down.svg"
import prevImage from "../images/Hero_Officers.jpg"
import nextImage from "../images/Hero_09_Markets.jpg"
import prevRings from "../images/RINGS_BLUE_YELLOW.svg"
import nextRings from "../images/RINGS_BLUE_YELLOW.svg"
import arrowLeft from "../images/yellow-arrow.svg"
import useWindowSize from "../components/hooks"
import "../components/summer-development.scss"
import "../components/pages.scss"
import SummerSVG from "../components/summer-svg.js"
import WinterSVG from "../components/winter-svg.js"
import ringsgy from "../images/RINGS_GREEEN_YELLOW.svg"
import ringsmy from "../images/RINGS_MAGENTA_YELLOW.svg"
import ringscy from "../images/RINGS_CYAN_YELLOW.svg"
import ringsbm from "../images/RINGS_BLUE_MAGENTA.svg"
import ringsby from "../images/RINGS_BLUE_YELLOW.svg"

gsap.registerPlugin(ScrollTrigger);

const OperationsPage = (props) => {
    const firstRow = useRef();
    const circles = useRef([]);
    const navList = useRef();
    const size = useWindowSize();
	const [desktopViewState, setDesktopViewState] = useState(null);
	const summerItems = useRef([]);
	const summerSVG = useRef();
	const [summerInt, setSummerInt] = useState(null);
	const accordionItem = useRef([]);
	const [accordInt, setAccordInt] = useState({currentOpen: null, prevOpen: null, open: false});
	const triggers = useRef([]);


    useEffect(() => {
		const mql = window.matchMedia('(min-width: 1024px)');
		setDesktopViewState(mql.matches);
	}, [size, desktopViewState]);

    useLayoutEffect(() => {
        // console.log(circles);
        for(let x = 0; x < circles.current.length; x++) {
            gsap.to(circles.current[x], {
                x: (i, target) => -1000 * target.dataset.speed,
                ease: "none",
                scrollTrigger: {
                    trigger: circles.current[x],
                    scrub: true,
                }
            });
        }

        gsap.from(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }, []);

    function exitAnimation(exit, node, int) {
        gsap.to(navList.current, {
            y: "-100%",
            duration: .35,
            ease: "power2"
        });
    }

    

    return (
        <Layout>
            <main className="page operations">
                <title>Operations</title>
                <div className="row nav">
                    <div className="col-xs-12">
                        <nav>
                            <ul ref={navList}>
                                <li>
                                <Link
                                        className="back-button"
                                        activeClassName="active"
                                        to="/"
                                        state={{ pageId: 3 }}
                                    >
                                        <img src={arrowLeft} alt=""/>
                                    </Link>
                                </li>
                                <li className="blue-bar">|</li>
                                <li data-url="operations" className="text--yellow">Operations</li>
                            </ul>
                        </nav>
                    </div>
                </div>
                <div className="page-set">
                    <div className="wrapper">
                        <div className="container">
                            <section className="panel">
                                <div className="wrap">
                                    <div className="profile">
                                        <StaticImage loading="eager" placeholder="blurred" quality="50" objectFit="contain" className="avatar" src="../images/Hero_04_Operations_REV.jpg" alt="" />
                                        <img className="rings" src={ringsmy} alt="" /> 
                                    </div>
                                    <div className="info">
                                        <div className="title--super text--outline">MEETING CRITICAL</div>
                                        <h1>NEEDS</h1>
                                        <div className="button-wrap">
                                            <TransitionLink
                                                className="button"
                                                to="/"
                                                exit={{
                                                    
                                                }}
                                                entry={{
                                                }}
                                            >
                                                Read Welcome
                                            </TransitionLink>
                                        </div>
                                    </div>
                                    <img className="chevron-down" src={chevronDown} alt="" /> 
                                </div>
                                <div 
                                    className="circle--pink top"
                                    ref={(element) => circles.current[0] = element}
                                    data-speed=".3"
                                ></div>
                                <div
                                    className="circle--blue top" 
                                    ref={(element) => circles.current[1] = element}
                                    data-speed="-.1"
                                ></div>
                                <div
                                    className="circle--green top" 
                                    ref={(element) => circles.current[2] = element}
                                    data-speed="-.1"
                                ></div>
                            </section>
                        </div>
                    </div>
                </div>
                <div className="row row-wrapper first-row content" ref={firstRow}>
                   <div className="col-xs-12">
                        <p className="text text--intro">PJM and its members and stakeholders continuously plan, prepare and coordinate operations to meet the critical need for electricity for 65 million people in 13 states and the District of Columbia, no matter the weather or unforeseen system conditions.</p>
                        <p className="text text--intro">The 1,436 electric power generators and 85,103 miles of transmission lines in the PJM region are owned by a wide range of public utilities and independent companies. As a federally designated grid reliability authority, PJM coordinates the operation of these facilities on a moment-by-moment basis using a principle referred to as Security Constrained Economic Dispatch.</p>                    
                        <h5 className="m-t-60">COVID-19</h5>
                        <p className="text">During the second year of the COVID-19 pandemic, PJM took many proactive steps to safeguard our employees, the grid and our campuses and reliably operate the high-voltage electric system.</p>
                   </div>
                 </div>
                 <div className="row row-wrapper content m-t-20">
                   <div className="col-xs-12 col-md-6">
                   		<h6>2021 COVID-19 Pandemic Highlights</h6>
                        <ul>
                            <li>PJM's internal Incident Response Team met regularly on pandemic-related issues and kept employees and stakeholders informed.</li>
                            <li>Our electricity markets and the bulk power system continued normal operations.</li>
                            <ul className="nested-list">
                                <li>PJM remained in close communication with regulatory, industry and government entities.</li>
                                <li>PJM supported all market applications from our campus and remotely.</li>
                                <li>PJM sequestered teams from operations from December 2020 through March 2021 and operated out of three different control rooms for the second time during the pandemic. </li>
                            </ul>
                            <li>For employees not working on our campuses, PJM continued its remote work posture and virtual stakeholder meetings throughout 2021.</li>
                            <li>In July 2021, PJM conducted a three-week pilot program for employees on its Valley Forge campus, which made it easier to return to campus.</li>
                            
                        </ul>
                   </div>
                   <div className="col-xs-12 col-md-6 rel">
                        <div className="profile__wrap">
                            <div className="profile profile--med profile--left">
                                <StaticImage loading="lazy" placeholder="blurred" quality="50" objectFit="contain" className="avatar" src="../images/Operations_PandemicHightlights_01.jpg" alt="" />
                                <img className="rings" src={ringsgy} alt="" /> 
                            </div>
                            <div className="profile profile--med profile--right">
                                <StaticImage loading="lazy" placeholder="blurred" quality="50" objectFit="contain" className="avatar" src="../images/Operations_PandemicHightlights_02.jpg" alt="" />
                                <img className="rings" src={ringsbm} alt="" /> 
                            </div>
                        </div>
                   </div>
               </div>
               <div className="row row-wrapper content m-t-20 align-center">
                   <div className="col-xs-12 col-md-4 mobile-order-2">
                        <div className="profile profile--med">
                            <StaticImage loading="lazy" placeholder="blurred" quality="50" objectFit="contain" className="avatar" src="../images/Operations_PandemicHightlights_03.jpg" alt="" />
                            <img className="rings" src={ringsmy} alt="" /> 
                        </div>
                   </div>
                   <div className="col-xs-12 col-md-8">
                        <h6>COVID-19 Vaccine Requirement Established</h6>
                        <p className="text">In late fall, PJM announced it would require COVID-19 vaccination for all on-campus personnel and for <nobr>in-person</nobr> attendance at PJM facilities or events, effective Jan. 4, 2022.</p>
                        <ul>
                            <li>The COVID-19 vaccine requirement applies to employees, contractors, vendors, members and other stakeholders who visit a PJM campus or attend any in&nbsp;-&nbsp;person PJM event, on or off campus.</li>
                            <li>Virtual attendance options remain available for stakeholder and member meetings.</li>
                        </ul>
                   </div>
                </div>
                <div className="row row-wrapper content m-t-40">
                   <div className="col-xs-12">
                   		<h6>Flexible and Informed Approach</h6>
                        <p className="text">PJM's COVID-19 plans were conducted in a phased approach that is continuously informed and refined with guidance from:</p>
                        <div className="flex-list">
                            <ul>
                                <li>Pennsylvania governor's office on COVID-19</li>
                                <li>Pennsylvania Department of Health</li>
                                <li>Montgomery County, PA </li>
                                <li>Centers for Disease Control and Prevention</li>
                            </ul>
                            <ul>
                                <li>PJM Pandemic Plan</li>
                                <li>PJM business impact assessment</li>
                                <li>PJM epidemiologist consultant</li>
                            </ul>
                        </div>
                   </div>
                </div>
                <div className="row row-wrapper content m-t-40">
                   <div className="col-xs-12">
                   		<h5 className="text--uppercase">Summer Reliability</h5>
                        <p className="text">Peak load conditions typically take place during the hottest weather of the year. PJM and its members continually coordinated to prepare for peak load operations throughout 2021.</p>
                        <p className="text">By summer, the energy impacts surrounding the COVID-19 pandemic subsided, and demand for electricity began to return to normal. PJM’s Load Forecast Report estimated that summer demand in 2021 would exceed that of 2020.</p>
                   </div>
                </div>

                <div className="rel">
                    <SummerSVG />
                    <div 
                        className="circle--pink top-2"
                        ref={(element) => circles.current[4] = element}
                        data-speed=".3"
                    ></div>
                </div>

	    	    <div className="sec-pad">
	                <div className="bg-blue p-t-40 p-b-40 m-b-40">
	                    <div className="row row-wrapper content max--1024">
	                        <div className="col-xs-12 text--center">
	                            <p className="text text--yellow text--large quote-text">&#8220;Keeping the power flowing and the grid reliable is the core mission for PJM and our member companies. We understand the critical importance that electricity plays in the daily lives of the 65 million people we&nbsp;serve.&#8221;</p>
	                            <p className="text text--yellow text--uppercase text--large quote-name">Manu Asthana, President & CEO</p>
	                        </div>
	                    </div>
	                </div>
                </div>
                <div className="row row-wrapper content">
                   <div className="col-xs-12">
                        <h5 className="m-t-60">Prepared For Winter</h5>
                        <p className="text">Each year, PJM collaborates with members and stakeholders to perform winter readiness assessments and exercises well in advance of cold weather. Peak season preparations include the winter operations forecast. To prepare for winter, PJM analyzes the expected demand for electricity, weather predictions and other factors. Long before temperatures fell, PJM enhanced its winter preparedness to reflect dynamic market conditions, surveyed for fuel supply concerns and implemented lessons learned from extreme cold weather events in early 2021.</p>
                   </div>
                </div>
                <div className="row row-wrapper content m-t-40">
                   <div className="col-xs-12">
                        <h6>Cold Snap Drove Record Exports</h6>
                        <p className="text">As severe winter weather took hold in mid-February and disrupted grid reliability in Texas, the Midwest ISO region and the Southwest Power Pool region, PJM and its members maintained the reliable operation of the bulk power system in our footprint. </p>
                        <p className="text">At the same time, PJM exported record amounts of electricity to support increased demand experienced by neighboring grid systems and states.</p>
                        <p className="text">Prior close coordination by PJM members and other stakeholders to prepare for unforeseen outages or system disruptions positioned PJM to provide this critical assistance.</p>
                   </div>
                </div>
                <div className="row row-wrapper content ball-stat m-t-40 m-b-40">
                    <div className="col-xs-12 col-md-6 bg-blue col-md-offset-1">
                        <div className="stat__item text--center">
                        	<p className="text--white text--bold stat-text">During winter storm Uri, PJM exported</p>
                        	<p className="stat__text-large text--yellow">15,763 MW</p>
                        	<p className="text--white text--bold stat-text">on Feb. 15, 2021.</p>
                        </div>
                    </div>
                    <div className="col-xs-12 col-md-3 ball-stat-wrap rel">
                    	<div className="ball__item">
                    		<div className="circle--blue"></div>
                    		<div className="info">
                    			<div className="text text--large text--white stat text--bold">4</div>
                    			<div className="text text--large text--white">COLD WEATHER ALERTS ISSUED IN FEBRUARY</div>
                    		</div>	
                    	</div>
                    </div>
                </div> 
            
                <div className="rel">
                    <WinterSVG />
                    <div 
                        className="circle--green top-2"
                        ref={(element) => circles.current[5] = element}
                        data-speed=".3"
                    ></div>
                </div>
				<div className="row row-wrapper content">
					<div className="col-xs-12">
						<h6 className="text--uppercase">Extreme Weather Analysis Drives Close Coordination for Winter 2021/2022</h6>
						<p className="text">Preparing for winter is a team effort. </p>
                        <p className="text">PJM's preparation checklist for generation and transmission owners includes everything from increasing staffing for weather emergencies to performing required maintenance activities to prepare equipment for winter conditions. Review of these winter procedures and preparations with federal and state regulators and neighboring grid operators are a fundamental part of PJM's winter preparations.</p>
						<p className="text">In addition, PJM conducts weekly review meetings with major natural gas pipeline operators serving natural gas-fired generators in the PJM footprint. This regular cadence of communication coordinates operations with the pipelines critical to PJM's gas generation fleet.</p>
						<p className="text">To help ensure critical supplies are in place, PJM also collects and assesses data on multiple factors, including:</p>
                        <ul>
                            <li>Fuel inventories</li>
                            <li>Supply and delivery characteristics</li>
                            <li>Emission limits</li>
                            <li>Minimum operating temperatures</li>
                        </ul>
                        <p className="text">When preparing for the 2021/2022 winter, PJM and its stakeholders partnered to expand the playbook for winter preparedness. Extensive industry and government studies of severe cold weather issues in Texas and southwest states resulted in additional precautionary measures to ensure the reliable flow of power:</p>
                        <ul>
                            <li>Coordinating with transmission owners to identify and prioritize electric service for critical facilities in emergencies </li>
                            <li>Collecting more information from suppliers to address potential fuel supply concerns</li>
                            <li>Enhancing coordination with the natural gas industry</li>
                            <li>Implementing weekly data requests for assessment of fuel availability</li>
                            <li>Studying load shed procedures to ensure reliable power to critical load</li>
                        </ul>
                        <h5 className="m-t-60">Supply Chain Issues Addressed for Reliability</h5>
                        <p className="text">To enhance critical reliability tools, temporary changes to PJM Emergency Operations procedures were approved by stakeholders in the fall of 2021. Spurred by volatile commodity markets affecting coal and natural gas supplies worldwide, temporary changes to PJM Manual 13 granted needed flexibility to manage generation dispatch in response to possible local or regional reliability concerns resulting from fuel supply shortages. </p>
                        <p className="text">The changes were designed to help in the event of potential fuel supply shortages or extreme weather.</p>
					</div>
				</div>
                <div className="sec-pad">
	                <div className="bg-blue p-t-40 p-b-40 m-b-40">
	                    <div className="row row-wrapper content max--1024">
	                        <div className="col-xs-12 text--center">
	                            <p className="text text--yellow text--large quote-text">&#8220;These enhanced, coordinated efforts were incredibly helpful as we worked with our stakeholders to prepare for a reliable and resilient system even in the most extreme weather conditions.&#8221;</p>
	                            <p className="text text--yellow text--uppercase text--large quote-name">Mike Bryson, Senior Vice President – Operations</p>
	                        </div>
	                    </div>
	                </div>
                </div>						
            </main>
            <Footer 
                nextLink="/markets" 
                nextImage={nextImage}
                nextText="Next &gt;"
                nextButton="Read More"  
                nextTitle="Markets" 
                nextRings={nextRings}
                prevLink="/officers" 
                prevImage={prevImage}
                prevText="&lt; Previous"
                prevButton="Read More"
                prevTitle="Officers"  
                prevRings={prevRings}
            />
        </Layout>
    )
}

export default OperationsPage